import { NgFor } from '@angular/common';
import { AfterViewInit, CUSTOM_ELEMENTS_SCHEMA, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { CardRicercheRecentiComponent } from '../card-search-annunci-recenti/card-search-annunci-recenti.component';

Swiper.use([Navigation]);

@Component({
  selector: 'app-carousel-annunci-recenti',
  templateUrl: './carousel-annunci-recenti.component.html',
  styleUrls: ['./carousel-annunci-recenti.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NgFor, CardRicercheRecentiComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CarouselAnnunciRecentiComponent implements OnInit, AfterViewInit {
  @Input() contentArray: any[];

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const swiper = new Swiper('.swiper', {
      loop: this.contentArray && this.contentArray?.length > 2,
      spaceBetween: 10,
      breakpoints: {
        768: {
          width: 768,
          slidesPerView: 2.4,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }

  onSwiper(swiper: Event): void {
    //
  }
  onSlideChange(): void {
    //
  }
}
